import { computed, ref } from "vue";
import { useStore } from "@/store";

/* eslint-disable no-unused-vars */
class ComponenteFotoConfirmacaoService {
    setup({ identificador, modulo }) {
        const store = useStore();
        const modulosfotos = ref([])
        const modulos = computed(() => {
            return store.state.modulos.filter(module => parseInt(module.idChecklistModulo) !== parseInt(modulo))
        })

        modulos.value.forEach(module => {
            let componenteFoto = null;
            Object.entries(module.etapas.componentes).forEach(([key, value]) => {
                Object.entries(value).forEach(([chave, valor]) => {
                    if (valor.chave == 'foto' && valor.respostas !== null) {
                        componenteFoto = valor;
                    }
                })
            })

            if (componenteFoto) {
                const retornoModulo = {
                    idChecklistModulo: module.idChecklistModulo,
                    nome: module.localRealizacao,
                    fotos: []
                }
                Object.entries(componenteFoto.respostas).forEach(([key, resposta]) => {
                    retornoModulo.fotos.push({
                        id: key,
                        imagemUpload: resposta.imagem,
                        label: resposta.nome.split('_')[1],
                        observacao: resposta.observacao,
                        idArquivoChecklistModular: resposta.idArquivoChecklistModular
                    });
                });
                modulosfotos.value.push(retornoModulo)
            }
        })

        return {
            idComponente: identificador,
            modulosfotos
        };
    }
}

export default new ComponenteFotoConfirmacaoService();